<template>
  <div>
    <div class="all-users-page">
      <h1 class="page-header color-1-100">Task categories</h1>
    </div>
    <div class="content-section">
      <div class="data-list-heading">
        <div class="data-list-statusbar">
          <div class="data-list-statusbar__contains data-list-statusbar__block">{{ chapters.length }} task categories
          </div>
        </div>
        <a href="#"
           v-on:click.prevent="displayAddForm()"
           class="data-list-add"
           :class="[{ 'data-list-add__close': addFormDisplay}]"
           tabindex="-1">Add new task category</a>
      </div>
      <div class="categories-add-form" v-if="addFormDisplay">
        <div class="form-group">
          <div class="form-element">
            <label for="input-chapter-name" class="form-label color-2-63">Category Name</label>
            <input type="text"
                   id="input-chapter-name"
                   class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                   v-model="newChapter.name"/>
          </div>
          <div class="form-element">
            <label for="chapter-slug" class="form-label color-2-63">Slug</label>
            <input
                    name="chapter-desc"
                    id="chapter-slug"
                    v-model="newChapter.slug"
                    class="form-control form-control__input background-1-10-disabled  border-1-10-disabled" />
          </div>
          <div class="form-element">
            <label for="chapter-slug" class="form-label color-2-63">Color</label>
            <input
                    type="color"
                    name="chapter-desc"
                    id="chapter-color"
                    v-model="newChapter.color"
                    class="form-control form-control__color" />
          </div>
        </div>
        <div class="form-group">
          <div class="form-element featured-image">
            <span class="form-label color-2-63">Image (blue)</span>
            <label class="form-label color-2-63 form-label--file-upload" v-show="!isThumbnailFileUploadedBlue">
              <div class="upload-text">+Upload image</div>
              <input
                      type="file"
                      id="uploadThumbnail_blue_0"
                      name="Thumbnail"
                      data-vv-as='"Thumbnail"'
                      value.sync="formInfo.thumbnail"
                      v-validate.reject="veeValidateFileUploadRules"
                      @change="onThumbnailFileChange($event, 0, 'blue')"
                      class="form-control form-control--file" />
            </label>
            <div class="thumbnailFilePreview" v-if="isThumbnailFileUploadedBlue" v-bind:style="{ backgroundImage: 'url(' + newChapter.image + ')' }" ></div>
            <button
                    type="button"
                    v-if="isThumbnailFileUploadedBlue"
                    @click="removeThumbnail(0, 'blue')"
                    class="btn btn--remove-element">
              <span class="btn__text">-Remove image</span>
            </button>
          </div>
          <div class="form-element featured-image">
            <span class="form-label color-2-63">Image (gray)</span>
            <label class="form-label color-2-63 form-label--file-upload" v-show="!isThumbnailFileUploadedGray">
              <div class="upload-text">+Upload image</div>
              <input
                      type="file"
                      id="uploadThumbnail_gray_0"
                      name="Thumbnail"
                      data-vv-as='"Thumbnail"'
                      value.sync="formInfo.thumbnail"
                      v-validate.reject="veeValidateFileUploadRules"
                      @change="onThumbnailFileChange($event, 0, 'gray')"
                      class="form-control form-control--file" />
            </label>
            <div class="thumbnailFilePreview" v-if="isThumbnailFileUploadedGray" v-bind:style="{ backgroundImage: 'url(' + newChapter.imageGray + ')' }" ></div>
            <button
                    type="button"
                    v-if="isThumbnailFileUploadedGray"
                    @click="removeThumbnail(0, 'gray')"
                    class="btn btn--remove-element">
              <span class="btn__text">-Remove image</span>
            </button>
          </div>
          <div class="form-element featured-image">
            <span class="form-label color-2-63">Image (high contrast)</span>
            <label class="form-label color-2-63 form-label--file-upload" v-show="!isThumbnailFileUploadedHigh">
              <div class="upload-text">+Upload image</div>
              <input
                      type="file"
                      id="uploadThumbnail_high_0"
                      name="Thumbnail"
                      data-vv-as='"Thumbnail"'
                      value.sync="formInfo.thumbnail"
                      v-validate.reject="veeValidateFileUploadRules"
                      @change="onThumbnailFileChange($event, 0, 'high')"
                      class="form-control form-control--file" />
            </label>
            <div class="thumbnailFilePreview" v-if="isThumbnailFileUploadedHigh" v-bind:style="{ backgroundImage: 'url(' + newChapter.imageHigh + ')' }" ></div>
            <button
                    type="button"
                    v-if="isThumbnailFileUploadedHigh"
                    @click="removeThumbnail(0, 'high')"
                    class="btn btn--remove-element">
              <span class="btn__text">-Remove image</span>
            </button>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="form-group">
          <div class="form-element">
            <label for="textarea-chapter-desc" class="form-label color-2-63">Key information</label>
            <vue-editor
                    name="content"
                    :editorToolbar="editorToolbar"
                    class="form-control form-control__editor"
                    v-model="newChapter.description" />
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="update-data update-data__details">
          <a href="#" v-on:click.prevent="closeAddForm()" class="cancel-edit background-2-7 color-2-100 cancel-edit-details">Cancel</a>
          <a href="#" v-on:click.prevent="createCategory()" class="save-edit background-1-100 color-2-100 save-edit-details">Create task category</a>
        </div>
        <hr class="add-form-delimiter" />
      </div>
      <div class="data-list-body">
        <table class="table table-data">
          <thead class="categories-list-body__head">
          <tr>
            <th class="cellpadding categories-list-body__head_id table-head-ceil">ID</th>
            <th class="cellpadding categories-list-body__head_id table-head-ceil">Image</th>
            <th class="categories-list-search-col text-left categories-list-body__head_search table-head-ceil">
              <div class="table-search-wrap">
                <div class="wrap-input">
                  <input
                          v-model="searchString"
                          type="search"
                          class="table-search"
                          placeholder="Category name..."/>
                </div>
                <div class="wrap-search-icon"></div>
              </div>
            </th>
            <th class="cellpadding categories-list-body__head_id table-head-ceil">Slug</th>
            <th colspan="2" class="cellpadding categories-list-body__head_actions table-head-ceil">Actions</th>
          </tr>
          </thead>
          <tbody class="categories-list-body__body">
          <tr v-for="(chapter, i) in updatedChapters">
            <td class="text-center cellpadding" v-if="chapter.type === 'show'" style="width: 50px;">
              {{chapter.id}}
            </td>
            <td class="cellpadding" v-if="chapter.type === 'show'" style="width: 50px;">
              <div class="thumbnailFilePreview" v-if="chapter.image" v-bind:style="{ backgroundImage: 'url(' + chapter.image + ')' }" style="width: 50px; height: 50px; border: none;"></div>
            </td>
            <td class="cellpadding" v-if="chapter.type === 'show'">
              {{ chapter.name }}
            </td>
            <td class="cellpadding" v-if="chapter.type === 'show'">
              {{chapter.isChild ? '- ' + chapter.slug : chapter.slug}}
            </td>
            <td class="cellpadding text-center" v-if="chapter.type === 'show'" style="width: 50px;">
              <button
                      type="button"
                      class="table-crud-btn icon-btn-m edit-btn"
                      @click="showEditionForm(chapter.id)">
                <span class="table-tooltip">Edit</span>
              </button>
            </td>
            <td class="cellpadding text-center" v-if="chapter.type === 'show'" style="width: 50px;">
              <button
                      type="button"
                      class="table-crud-btn icon-btn-m delete-btn"
                      @click="removeCategory(chapter.id)">
                <span class="table-tooltip">Delete</span>
              </button>
            </td>
            <td colspan="6" v-if="chapter.type === 'edit'" class="edit-row chapter-edit">
              <div class="wrap-edit-form">
                <div class="row-edit-form">
                  <div>
                    <div class="form-group">
                      <div class="form-element featured-image">
                        <label class="form-label color-2-63 form-label--file-upload" v-show="!chapter.image">
                          <div class="upload-text">+Upload image</div>
                          <input
                                  type="file"
                                  :id="'uploadThumbnail_blue_' + chapter.id"
                                  name="Thumbnail"
                                  data-vv-as='"Thumbnail"'
                                  value.sync="formInfo.thumbnail"
                                  v-validate.reject="veeValidateFileUploadRules"
                                  @change="onThumbnailFileChange($event, chapter.id, 'blue')"
                                  class="form-control form-control--file" />
                        </label>
                        <div class="thumbnailFilePreview" v-if="chapter.image" v-bind:style="{ backgroundImage: 'url(' + chapter.image + ')' }" ></div>
                        <button
                                type="button"
                                v-if="chapter.image"
                                @click="removeThumbnail(chapter.id, 'blue')"
                                class="btn btn--remove-element">
                          <span class="btn__text">-Remove image</span>
                        </button>
                      </div>
                      <div class="form-element featured-image">
                        <label class="form-label color-2-63 form-label--file-upload" v-show="!chapter.imageGray">
                          <div class="upload-text">+Upload image</div>
                          <input
                                  type="file"
                                  :id="'uploadThumbnail_gray_' + chapter.id"
                                  name="Thumbnail"
                                  data-vv-as='"Thumbnail"'
                                  value.sync="formInfo.thumbnail"
                                  v-validate.reject="veeValidateFileUploadRules"
                                  @change="onThumbnailFileChange($event, chapter.id, 'gray')"
                                  class="form-control form-control--file" />
                        </label>
                        <div class="thumbnailFilePreview" v-if="chapter.imageGray" v-bind:style="{ backgroundImage: 'url(' + chapter.imageGray + ')' }" ></div>
                        <button
                                type="button"
                                v-if="chapter.imageGray"
                                @click="removeThumbnail(chapter.id, 'gray')"
                                class="btn btn--remove-element">
                          <span class="btn__text">-Remove image</span>
                        </button>
                      </div>
                      <div class="form-element featured-image">
                        <label class="form-label color-2-63 form-label--file-upload" v-show="!chapter.imageHigh">
                          <div class="upload-text">+Upload image</div>
                          <input
                                  type="file"
                                  :id="'uploadThumbnail_high_' + chapter.id"
                                  name="Thumbnail"
                                  data-vv-as='"Thumbnail"'
                                  value.sync="formInfo.thumbnail"
                                  v-validate.reject="veeValidateFileUploadRules"
                                  @change="onThumbnailFileChange($event, chapter.id, 'high')"
                                  class="form-control form-control--file" />
                        </label>
                        <div class="thumbnailFilePreview" v-if="chapter.imageHigh" v-bind:style="{ backgroundImage: 'url(' + chapter.imageHigh + ')' }" ></div>
                        <button
                                type="button"
                                v-if="chapter.imageHigh"
                                @click="removeThumbnail(chapter.id, 'high')"
                                class="btn btn--remove-element">
                          <span class="btn__text">-Remove image</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="wrap-color-input">
                    <input type="color"
                           class="form-control form-control__color"
                           v-model="chapter.color">
                  </div>
                  <div class="wrap-title-input">
                    <input type="text"
                           class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                           v-model="chapter.name">
                  </div>
                  <div class="wrap-desc-textarea">
                    <vue-editor
                            name="content"
                            :editorToolbar="editorToolbar"
                            class="form-control form-control__editor"
                            v-model="chapter.description" />
                  </div>
                </div>
                <div class="wrap-table-control-panel">
                  <button type="button" @click="discardСhanges(chapter.id)">Cancel</button>
                  <button type="button" @click="editCategory(chapter.id)">Save</button>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import 'vue-awesome/icons/plus'
import 'vue-awesome/icons/search'
import 'vue-awesome/icons/pencil'
import 'vue-awesome/icons/folder'
import 'vue-awesome/icons/times'
import 'vue-awesome/icons/chevron-up'
import 'vue-awesome/icons/chevron-down'
import AppSelect from '@/components/admin/common/Select'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'chapters-list',
  data () {
    return {
      infMsgTitle: '',
      infMsgDescription: '',
      infMsgClass: '',
      chapters: [],
      updatedChapters: [],
      contentAutoloadInfo: {
        curPage: 1,
        numPages: 1,
        locked: false
      },
      newChapter: {
        name: '',
        slug: '',
        isActive: 1,
        description: '',
        image: null,
        imageGray: null,
        imageHigh: null,
        color: null
      },
      disableAPI: false,
      searchString: '',
      parent: null,
      statusbar: {
        filter: {
          isHover: false,
          style: {
            backgroundColor: '#fffdd8',
            borderColor: '#000'
          }
        }
      },
      hoverElements: [],
      filerTableHead: {
        selectedCeil: null
      },
      addFormDisplay: false,
      isThumbnailFileUploadedBlue: false,
      isThumbnailFileUploadedGray: false,
      isThumbnailFileUploadedHigh: false,
      isEditFileUploadedBlue: false,
      isEditFileUploadedGray: false,
      isEditFileUploadedHigh: false,
      editorToolbar: [
        [{'header': [1, 2, 3, false]}],
        ['bold', 'italic', 'underline', 'strike', {'color': []}],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        [{'indent': '-1'}, {'indent': '+1'}],
        ['blockquote', 'code-block', 'link'],
        [{'font': []}],
        [{'align': []}],
        ['clean']
      ]
    }
  },
  methods: {
    ...mapActions([
      'getCategories',
      'setInformationMsg',
      'clearConfAction',
      'initConfAction'
    ]),
    displayAddForm () {
      this.addFormDisplay = !this.addFormDisplay
    },
    closeAddForm () {
      this.addFormDisplay = !this.addFormDisplay
    },
    search () {
      if (!this.filter.search) {
        this.contentInfo.typeAutoLoad = 'allContent'
        this.fetchAllContentByScroll(1, 200)
        return
      }
      this.contentInfo.typeAutoLoad = 'searchContent'
      this.fetchSearchContent()
    },
    fetchSearchContent () {
      if (!this.filter.search) return
      let queryString = `${api.URLS.search}`
      Object.keys(this.filter).forEach((item) => {
        let value = this.filter[item]
        if (value && typeof (value) === 'string') {
          queryString += `&search=${value}`
        }
        if (value !== null && typeof (value) === 'object' && value.length) {
          let subString = ''
          value.forEach((it) => {
            subString += `&${item}=${it.value}`
          })
          queryString += subString
        }
      })
      if (this.contentType.length) queryString += '&contentType=' + this.contentType[0].value
      this.$http.get(`${queryString}`, api.headersAuthSettings)
        .then((res) => {
          let resData = res.body.data.items
          if (!resData) {
            this.articles = []
            return
          }
          this.articles = resData
        })
        .catch((err) => console.error(err))
    },
    removeCategory (id) {
      this.initConfAction({
        actionId: id,
        actionName: 'removeChapterById'
      })
    },
    removeChapterConfirmed (id) {
      let self = this
      let thisCategory = this.updatedChapters.find((chapter) => chapter.id === id)
      this.getCategories()
      this.$http.delete(api.URLS.chapter + '/' + id, api.headersAuthSettings)
          .then((res) => {
            self.infMsgTitle = thisCategory.name + ' chapter was successfully deleted.'
            self.infMsgDescription = 'Please note all actions are being logged.'
            self.infMsgClass = 'success'
            self.setInformationMsg({
              isShown: true,
              title: self.infMsgTitle,
              text: self.infMsgDescription,
              className: self.infMsgClass
            })
            for (let i = 0; i < self.chapters.length; i++) {
              if (self.chapters[i].id === id) {
                self.chapters.splice(i, 1)
                break
              }
            }
          })
          .catch((err) => console.log(err))
    },
    handleScroll (event) {
      let scrollHeight = Math.max(
        document.body.scrollHeight, document.documentElement.scrollHeight,
        document.body.offsetHeight, document.documentElement.offsetHeight,
        document.body.clientHeight, document.documentElement.clientHeight)
      let fullScrolledValue = window.pageYOffset + window.innerHeight

      if (fullScrolledValue > scrollHeight - 200) {
        this.fetchAllContentByScroll(++this.contentAutoloadInfo.curPage, 200)
      }
    },
    fetchAllContentByScroll (page, limit) {
      this.$http.get(api.URLS.chapters + '?limit=' + limit + '&page=' + page, api.headersAuthSettings)
        .then((res) => {
          if (res.body) {
            this.chapters = res.body
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    createCategory () {
      if (this.disableAPI) return
      if (!this.newChapter.name) return
      let formData = new FormData()
      formData.append('chapter[name]', this.newChapter.name)
      formData.append('chapter[slug]', this.newChapter.slug)
      formData.append('chapter[description]', this.newChapter.description)
      formData.append('chapter[image]', this.newChapter.image)
      formData.append('chapter[imageGray]', this.newChapter.imageGray)
      formData.append('chapter[imageHigh]', this.newChapter.imageHigh)
      formData.append('chapter[color]', this.newChapter.color)
      this.disableAPI = true
      this.$http.post(api.URLS.chapter, formData, api.headersAuthSettings)
        .then((res) => {
          this.disableAPI = false
          this.infMsgTitle = this.newChapter.name + ' chapter was successfully added.'
          this.infMsgDescription = 'Please note all actions are being logged.'
          this.infMsgClass = 'success'
          this.setInformationMsg({
            isShown: true,
            title: this.infMsgTitle,
            text: this.infMsgDescription,
            className: this.infMsgClass
          })
          this.newChapter.name = ''
          this.newChapter.slug = ''
          this.newChapter.description = ''
          this.newChapter.image = null
          this.newChapter.imageGray = null
          this.newChapter.imageHigh = null
          this.newChapter.color = null
          this.addFormDisplay = false
          this.isThumbnailFileUploadedBlue = false
          this.isThumbnailFileUploadedGray = false
          this.isThumbnailFileUploadedHIgh = false
          this.fetchAllContentByScroll(1, 200)
          this.getCategories
        })
        .catch((err) => {
          this.disableAPI = false
          console.log(err)
        })
    },
    showEditionForm (id) {
      for (let chapter of this.updatedChapters) {
        if (chapter.type === 'edit') chapter.type = null
        if (chapter.id === id && chapter.type === null) {
          chapter.type = 'edit'
        }
      }
    },
    editCategory (id) {
      if (this.disableAPI) return
      let chapter = this.updatedChapters.find((chapter) => chapter.id === id && chapter.type === 'edit')
      let formData = {
        chapter: {
          name: chapter.name,
          slug: chapter.slug,
          description: chapter.description,
          image: chapter.image,
          imageGray: chapter.imageGray,
          imageHigh: chapter.imageHigh,
          color: chapter.color
        }
      }
      if (chapter.parent && chapter.parent !== null) {
        formData.chapter.parent = chapter.parent.value
      }
      this.disableAPI = true
      this.$http.put(api.URLS.chapter + '/' + id, formData, api.headersAuthSettings)
        .then((res) => {
          this.disableAPI = false
          console.log('updateCategory', res)
          this.discardСhanges(id)
          this.fetchAllContentByScroll(1, 200)
          let infMsg = 'Category has been successfully updated'
          this.setInformationMsg({text: infMsg, className: 'success'})
        })
        .catch((err) => {
          this.disableAPI = false
          console.log(err)
        })
    },
    discardСhanges (id) {
      for (let chapter of this.updatedChapters) {
        if (chapter.id === id && chapter.type === 'edit') {
          chapter.type = null
        }
      }
    },
    removeSelectedFilters (filter) {
      this.parent = null
    },
    removeAllFilters () {
      this.parent = null
    },
    addHoverElement (elements) {
      this.hoverElements = elements
    },
    removeHoverElements () {
      this.hoverElements = []
    },
    isExist (element) {
      let el = this.hoverElements.find(item => {
        if ((element.value === item.value || item.value === null) && element.label === item.label) {
          return true
        }
      })
      return !!el
    },
    showHideSubMenu (num) {
      if (!this.filerTableHead.selectedCeil) {
        this.filerTableHead.selectedCeil = num
      } else {
        this.filerTableHead.selectedCeil === num ? this.filerTableHead.selectedCeil = null : this.filerTableHead.selectedCeil = num
      }
    },
    hideSubMenuTableHead (e) {
      this.filerTableHead.selectedCeil = null
    },
    isExistInOptions (options) {
      let hoverElement = this.hoverElements.length ? this.hoverElements[0] : {}
      let el = options.find(item => {
        if ((hoverElement.value === item.value || hoverElement.value === null) && hoverElement.label === item.label) {
          return true
        }
      })
      return !!el
    },
    onThumbnailFileChange (e, id, type) {
      let self = this
      let input = document.getElementById('uploadThumbnail_' + type + '_' + id)
      if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif|svg)$/i)) {
        let reader = new FileReader()
        if (id === 0) {
          reader.onload = function (e) {
            if (type === 'blue') {
              self.isThumbnailFileUploadedBlue = true
              self.newChapter.image = e.target.result
            }
            if (type === 'gray') {
              self.isThumbnailFileUploadedGray = true
              self.newChapter.imageGray = e.target.result
            }
            if (type === 'high') {
              self.isThumbnailFileUploadedHigh = true
              self.newChapter.imageHigh = e.target.result
            }
          }
        } else {
          let chapter = this.updatedChapters.find((chapter) => chapter.id === id && chapter.type === 'edit')
          reader.onload = function (e) {
            if (type === 'blue') {
              self.isEditFileUploadedBlue = true
              chapter.image = e.target.result
            }
            if (type === 'gray') {
              self.isEditFileUploadedGray = true
              chapter.imageGray = e.target.result
            }
            if (type === 'high') {
              self.isEditFileUploadedHigh = true
              chapter.imageHigh = e.target.result
            }
          }
        }
        reader.readAsDataURL(input.files[0])
      }
    },
    removeThumbnail (id, type) {
      var input = document.getElementById('uploadThumbnail_' + type + '_' + id)
      input.value = null
      if (id === 0) {
        if (type === 'blue') {
          this.isThumbnailFileUploadedBlue = false
          this.newChapter.image = null
        }
        if (type === 'gray') {
          this.isThumbnailFileUploadedGray = false
          this.newChapter.imageGray = null
        }
        if (type === 'high') {
          this.isThumbnailFileUploadedHigh = false
          this.newChapter.imageHigh = null
        }
      } else {
        let chapter = this.updatedChapters.find((chapter) => chapter.id === id && chapter.type === 'edit')
        if (type === 'blue') {
          this.isEditFileUploadedBlue = false
          chapter.image = null
        }
        if (type === 'gray') {
          this.isEditFileUploadedGray = false
          chapter.imageGray = null
        }
        if (type === 'high') {
          this.isEditFileUploadedHigh = false
          chapter.imageHigh = null
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'getCategoriesTitle',
      'getCategoriesForSelect',
      'parentCategoriesForSelect',
      'getTagsForSelect',
      'getConfData'
    ]),
    veeValidateFileUploadRules () {
      return {
        required: false,
        mimes: 'image/*'
      }
    },
    filteredCategories () {
      return this.chapters.filter((chapter) => chapter.name.toLowerCase().indexOf(this.searchString.toLowerCase()) > -1)
        .filter((chapter) => this.parent === null || (chapter.parent && chapter.parent.value === this.parent.value))
    }
  },
  watch: {
    filteredCategories: function () {
      let updatedChapters = []
      this.filteredCategories.forEach((chapter, i, arr) => {
        chapter.type = 'show'
        updatedChapters.push(chapter)
        updatedChapters.push({
          type: null,
          id: chapter.id,
          name: chapter.name,
          slug: chapter.slug,
          description: chapter.description,
          image: chapter.image,
          imageGray: chapter.image_gray,
          imageHigh: chapter.image_high,
          color: chapter.color
        })
      })
      this.updatedChapters = updatedChapters
    },
    'getConfData.actionConfirmed' (value) {
      let actionName = this.getConfData.actionName
      if (value) {
        switch (actionName) {
          case 'removeChapterById':
            this.removeChapterConfirmed(this.getConfData.actionId)
            this.clearConfAction()
            break
        }
      }
    }
  },
  components: {
    AppSelect
  },
  mounted () {
    this.fetchAllContentByScroll(1, 200)
    this.getCategories()
    document.addEventListener('click', this.hideSubMenuTableHead)
  },
  created () {
    document.title = 'Task categories | Clear Assured'
    if (window.ga) {
      window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
      window.ga('send', 'pageview', {
        'page': location.pathname,
        'location': location.href,
        'title': document.title
      })
    }
  },
  destroyed () {
    document.addEventListener('click', this.hideSubMenuTableHead)
  }
}
</script>

<style src='@/assets/scss/components/table.scss' lang='scss' scoped />



// WEBPACK FOOTER //
// ChaptersList.vue?31c49d3c